/*-- import aliases -----------
'!/...' -> project root
'~/...' -> vue folder root
'@/...' -> src folder root
-----------------------------*/

import Vue from 'vue';
import Store from '@/communities-listing/store';
// import Router from '@/my-app/router';
import App from '@/communities-listing/App';

Vue.config.devtools = true;
Vue.config.productionTip = false;

window.addEventListener('DOMContentLoaded', () => {
  const element = document.querySelector('#communitiesListingApp');
  if (element) {
    const app = new Vue({
      store: new Store().store,
      // router: new Router().router,
      data: () => Object.assign({}, element.dataset),
      render: h => h(App)
    });
    app.$mount(element);
  }
})
